import { Box, Paper, styled, TableCell, TableContainer, tablePaginationClasses, TableRow } from '@mui/material';
import { theme } from 'v3/styles/global-styles';
import { ITableCell } from './types';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  padding: '3.5rem 1rem 0 1rem',
  flexGrow: 1,
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '2rem',
  justifyContent: 'flex-start',
}));

export const MoreVertIconStyled = styled('div')(() => ({
  backgroundColor: theme.palette.primary.dark,
  borderRadius: '0.5rem',
  verticalAlign: 'middle',
  marginLeft: '2rem',
  padding: '0.5rem',

  [theme.breakpoints.up('sm')]: {
    marginLeft: 0,
  },
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem',
}));

export const PaperStyled = styled(Paper)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const TableCellStyled = styled(TableCell)(({ theme }) => ({
  color: 'white',
  justifyContent: 'space-between',
  background: theme.palette.primary.dark,
  borderBottomColor: theme.palette.secondary.dark,
}));

export const TableCellGroup = styled(TableCellStyled)(() => ({
  background: 'transparent',
  lineHeight: '1rem',
}));

export const TableCellInRow = styled('div')<ITableCell>(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '1rem',
}));

export const TableCellInColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  border: 'none',
  gap: '0.5rem',
}));

export const TableRowStyled = styled(TableRow)(() => ({
  cursor: 'pointer',
}));

export const TableContainerStyled = styled(TableContainer)(() => ({
  maxHeight: '28.25rem',
  width: '100%',
}));

export const TablePaginationStyles = {
  color: 'white',

  [`& .${tablePaginationClasses.select}:focus`]: {
    backgroundColor: 'transparent',
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    color: theme.palette.common.white,
  },
};

export const DeviceImg = styled('img')(() => ({
  maxWidth: '3.5rem',
  maxHeight: '3.5rem',
}));

export const DeviceImageContainer = styled(Box)(() => ({
  width: '3.5rem',
  height: '3.5rem',
  display: 'flex',
  justifyContent: 'center',
}));

export const SelectPropsStyles = {
  MenuProps: {
    PaperProps: {
      sx: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        '& .MuiMenuItem-root': {
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
      },
    },
  },
};

export const UnsupportedValueCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  whiteSpace: 'normal',
  borderRadius: '.2rem',
  padding: '0.25rem',
  marginTop: '0.25rem',
  maxWidth: '8.5rem',
  minHeight: '2rem',
}));
